import { HttpClient } from '../httpClient';
import NotificationModel from '../models/notification';
import { BaseResponse, DataResponse } from '../responses/baseResponse';
import NotificationRequest from '../requests/notificationRequest';
import NotificationGroupType from '../models/notificationGroupType';

const httpClient = new HttpClient();

export const getNotificationById = async (notificationId: number) => {
  return httpClient.get<DataResponse<NotificationModel>>({
    url: `/v1/Notifications/${notificationId}`,
    requiresToken: true,
  });
};

export const getNotifications = async () => {
  return httpClient.get<DataResponse<NotificationModel[]>>({
    url: '/v1/Notifications',
    requiresToken: true,
  });
};

export const getUserNotifications = async () => {
  return httpClient.get<DataResponse<NotificationModel[]>>({
    url: '/v1/Notifications/User',
    requiresToken: true,
  });
};

export const getUserNotificationsByDisciplineId = async (disciplineId: number) => {
  return httpClient.get<DataResponse<NotificationModel[]>>({
    url: `/v1/Notifications/User/${disciplineId}`,
    requiresToken: true,
  });
};

export const getNotificationGroupTypes = async () => {
  return httpClient.get<DataResponse<NotificationGroupType[]>>({
    url: '/v1/Notifications/GroupTypes',
    requiresToken: true,
  });
};

export const createNotification = async (request: NotificationRequest) => {
  return httpClient.post<BaseResponse>({
    url: `/v1/Notifications`,
    payload: request,
    requiresToken: true,
  });
};

export const updateNotification = async (request: NotificationRequest) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/Notifications`,
    payload: request,
    requiresToken: true,
  });
};

export const deleteNotification = async (notificationId: number) => {
  return httpClient.post<DataResponse<number>>({
    url: `/v1/Notifications/${notificationId}/Delete`,
    requiresToken: true,
  });
};